import { isQueryApiError } from "@features/errors/libs/guards";
import { ClientGateway } from "@kex/api";
import { startSessionInterceptor } from "@kode-frontend/session-interceptor";
import { type AxiosInstance } from "axios";

import { closeSession, newSession } from "@entities/session";

import { getNewAccessToken } from "./api";
import { passwordExpired } from "./model/password-expired";

type Tokens = {
  accessToken: string;
};

const PASSWORD_EXPIRED_CODE = "ErrPasswordExpired";

export const refreshAccessTokenOnResponseError = (
  axiosInstance: AxiosInstance,
) => {
  startSessionInterceptor<Tokens>({
    invalidAccessTokenErrors: [
      {
        code: ClientGateway.ErrorResponseCodeEnum.ACCESS_TOKEN_EXPIRED,
        status: 409,
      },
    ],
    invalidRefreshTokenErrors: [
      {
        code: ClientGateway.ErrorResponseCodeEnum.ACCESS_TOKEN_INVALID,
        status: 400,
      },
      {
        code: ClientGateway.ErrorResponseCodeEnum.REFRESH_TOKEN_INVALID,
        status: 400,
      },
      {
        code: ClientGateway.ErrorResponseCodeEnum.REFRESH_TOKEN_EXPIRED,
        status: 400,
      },
      { code: ClientGateway.ErrorResponseCodeEnum.SESSION_CLOSED, status: 409 },
    ],
    storage: {
      storageGetter: (key) => {
        return localStorage.getItem(key);
      },
      storageSetter: (key, value) => {
        localStorage.setItem(key, value);
      },
    },
    tokensGetter: async (): Promise<Tokens> => {
      try {
        const { accessToken } = await getNewAccessToken();
        return { accessToken };
      } catch (error) {
        if (isQueryApiError(error) && error.code === PASSWORD_EXPIRED_CODE) {
          passwordExpired();
        }
        throw error;
      }
    },
    onGotNewTokens: ({ accessToken }) => {
      newSession({ accessToken });
    },
    onInvalidRefreshResponse: () => {
      closeSession();
    },
    onRefreshError: () => {
      closeSession();
    },
  })([axiosInstance]);
};
